import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Calendar } from "lucide-react";
import PageShell from "@/components/PageShell";
import Button from "@/components/Button";

const CONFETTI = [
  { color: "#3AB0FF", left: "10%", delay: "0s" },
  { color: "#FF6B6B", left: "25%", delay: "0.2s" },
  { color: "#FFD166", left: "40%", delay: "0.4s" },
  { color: "#34D399", left: "55%", delay: "0.1s" },
  { color: "#A78BFA", left: "70%", delay: "0.3s" },
  { color: "#FB7185", left: "85%", delay: "0.5s" },
];

export default function Success() {
  const navigate = useNavigate();
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {}
  }, []);

  return (
    <PageShell testid="success-screen" showFooter={false}>
      <section className="relative bg-sprouts-lavender overflow-hidden">
        {/* Confetti */}
        {CONFETTI.map((c, i) => (
          <span
            key={i}
            className="absolute top-0 w-2.5 h-3.5 rounded-sm animate-confetti-fall"
            style={{ left: c.left, backgroundColor: c.color, animationDelay: c.delay }}
            aria-hidden
          />
        ))}
        <div className="relative max-w-3xl mx-auto px-6 pt-16 pb-12 text-center">
          <div className="w-28 h-28 bg-sprouts-success rounded-full flex items-center justify-center mx-auto mb-6 shadow-card">
            <Check size={56} className="text-white" strokeWidth={3} />
          </div>
          <h1 className="text-2xl sm:text-3xl font-black text-sprouts-text">
            Your story has been submitted successfully!
          </h1>
          <p className="text-sm sm:text-base text-sprouts-muted mt-3 leading-relaxed">
            Thank you for sharing your travel memories with Sprouts. Our judges will review entries after the deadline
            and winners will be celebrated on this site and our socials.
          </p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-10">
        <div className="flex items-center gap-3 bg-white rounded-2xl p-5 border border-sprouts-border shadow-soft">
          <Calendar size={22} className="text-sprouts-primary shrink-0" />
          <div>
            <p className="font-extrabold text-sprouts-text">What's next?</p>
            <p className="text-sm text-sprouts-muted mt-0.5">
              Keep an eye on this site for shortlists and winners. Share the competition with your friends!
            </p>
          </div>
        </div>

        <div className="mt-5 flex flex-col gap-3 max-w-md mx-auto">
          <Button onClick={() => navigate("/submit", { replace: true })} data-testid="success-another" fullWidth>
            Submit Another Entry
          </Button>
          <Button variant="outline" onClick={() => navigate("/", { replace: true })} data-testid="success-home" fullWidth>
            Back to Home
          </Button>
        </div>
      </section>
    </PageShell>
  );
}
